// extracted by mini-css-extract-plugin
export default {"BlackView":"BlackView_BlackView__MwbDn","banner":"BlackView_banner__dbhxC"};